import { BlockquoteBranded, PageHeader } from '@folio/components';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Stack } from '@folio/components/ui/flex';

export function IntermediaryFunnelEndModule() {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const namespace = pathname.includes('/mta/') ? 'policyholderMta.end' : 'intermediaryFunnel.end';

  return (
    <Stack className="pt-10">
      <PageHeader title={t(`${namespace}.title`)} />
      <BlockquoteBranded>{t(`${namespace}.message`)}</BlockquoteBranded>
    </Stack>
  );
}
